import React, { useEffect } from 'react'
import NotFoundPage from '../NotFoundPage'
import { SurveyFeature } from '../../features/SurveyFeature'
import { useParams } from 'react-router-dom'
import PAGE_TITLES from '../../consts/titles'
import CustomHeader from '../../components/CustomHeader'
import { useAppDispatch } from '../../store'
import SkipNavigation from '../../components/SkipNavigation'
import { getStudentSurveyById, getStudentSurveyByIdPublic } from '../../store/slices/studentSurveyListSlice/apis'
import { getIsLoading } from '../../store/slices/studentSurveyListSlice/selectors'
import Loader from '../../components/Loader'

import { Container } from '@mui/material'

const SurveyPage: React.FC = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const { id = '' } = useParams()
  const queryParams = new URLSearchParams(location.search)
  const isPublic = queryParams.get('isPublic')
  const isPublicSurvey = isPublic === 'true'

  const loading = getIsLoading() ?? false

  useEffect(() => {
    if (!id) return

    if (isPublicSurvey) {
      void dispatch(getStudentSurveyByIdPublic({ urlId: id }))
    } else {
      void dispatch(getStudentSurveyById({ urlId: id }))
    }
  }, [id, dispatch, isPublicSurvey])

  if (id == null) {
    return <NotFoundPage />
  }

  if (loading) {
    return <Loader open={loading} />
  }

  return (
    <>
      <SkipNavigation />
      <CustomHeader title={PAGE_TITLES.SURVEYS} />
      <Container sx={{ marginTop: isPublicSurvey ? 5 : 0, marginBottom: isPublicSurvey ? 18 : undefined }}>
        <SurveyFeature isPublic={isPublicSurvey || undefined} />
      </Container>
    </>
  )
}

export default SurveyPage
